// extracted by mini-css-extract-plugin
export var card = "_sf-0";